import { useQuery } from '@tanstack/react-query';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@upme/ui/components/select';
import { listCitiesOptions } from '../../cities/queries';

export function CityScopeSelect({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  const { data: cities = [] } = useQuery(listCitiesOptions());
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-64">
        <SelectValue placeholder="Уровень" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="global">Общие (все города)</SelectItem>
        {cities.map((c) => (
          <SelectItem key={c.id} value={c.id}>
            {c.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
